import { Component, Input, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { UpdateSelectedProcedure } from '../../../store/actions/selected-procedure.actions';
import { SaveMission } from '../../../store/actions/mission.actions';
import { ConstsHelper } from '../../../../../helpers/consts.helper';
import { GetCountries } from '../../../store/actions/countries.actions';
import { CountriesInterfaceState } from '../../../store/state/countries.state';
import { CountryInterface } from '../../../models/country.interface';
import { VoiceCallAssistance } from '../../../models/voice-call-assistance';
import { LineInterface } from '../../../../lines/models/line.interface';

@Component({
  selector: 'app-voice-call-assistance',
  templateUrl: './voice-call-assistance.component.html',
  styleUrls: ['./voice-call-assistance.component.css'],
  standalone: false
})
export class VoiceCallAssistanceComponent implements OnInit {
  @Input()
  line: LineInterface;

  @Input()
  procedureCode: string;
  constsHelper = ConstsHelper;
  voiceCallAssistance = new VoiceCallAssistance();
  countries: Array<CountryInterface>;
  step: number;
  displayedMessage: number = 0;
  displayedMessageValue: string = this.constsHelper.PROCEDURE_VOICE_CALL_ASSISTANCE_ERROR_MESSAGES[0].value;
  networkBarsNumber: number;
  operatorName: string;
  appearanceProblem: string = 'N\'a jamais fonctionné';
  audioProblem: number = 0;
  audioProblemValues: Array<string> = [];
  problemType: string = 'Emission d\'appels';
  problemTypeContact: string;
  problemDestination: string = 'En France';
  oldOperatorPhonePurchased: number;
  unlockedPhone: number;
  imeiPhone: number;
  brandPhone: string;
  modelPhone: string;
  crossTestDate: string;
  crossTestBrandPhone: string;
  crossTestModelPhone: string;
  crossTestResult: string = '1';
  minDate: string;
  maxDate: string;
  occurrenceFrequencyProblem: string = 'Aléatoire';
  usageType: string = 'Extérieur';
  operatorProblem: number;
  operatorProblemValue: string;
  correspondentProblem: number;
  correspondentProblemValue: string;
  incidentInformation: string = 'Localisé';
  incidentMagnitude: string = 'Une adresse';
  incidentMagnitudeCountry: string = 'France';
  lastCallProblemCorrespondent: string;
  lastCallProblemOperator: string;
  lastCallProblemDate: string;
  lastCallProblemAddress: string;
  lastCallProblemZipCode: string;
  lastCallProblemCity: string;

  errorNetworkBarsNumber: boolean;
  errorOperatorName: boolean;
  errorAudioProblem: boolean;
  errorProblemTypeContact: boolean;
  errorImeiPhone: boolean;
  errorBrandPhone: boolean;
  errorModelPhone: boolean;
  errorCrossTestDate: boolean;
  errorCrossTestBrandPhone: boolean;
  errorCrossTestModelPhone: boolean;
  errorOperatorProblemValue: boolean;
  errorCorrespondentProblemValue: boolean;
  errorLastCallProblemCorrespondent: boolean;
  errorLastCallProblemOperator: boolean;
  errorLastCallProblemDate: boolean;
  errorLastCallProblemAddress: boolean;
  errorLastCallProblemZipCode: boolean;
  errorLastCallProblemCity: boolean;
  formSubmitted: boolean;

  constructor(private store: Store<any>) {}
  
  ngOnInit() {
    this.store.pipe(select(ConstsHelper.REDUCER_COUNTRIES)).subscribe( (response: CountriesInterfaceState) => {
      if (null != response) {
        this.countries = response.list;
      }
    });

    this.store.dispatch(new GetCountries());
    this.step = 1;
    this.formSubmitted = false;
    const minDate = new Date();
    const maxDate = new Date();
    minDate.setDate(minDate.getDate() - 4);
    maxDate.setDate(maxDate.getDate());
    const minMonth = (minDate.getMonth() + 1) < 10 ? '0' + (minDate.getMonth() +  1) : (minDate.getMonth() + 1);
    const maxMonth = (maxDate.getMonth() + 1) < 10 ? '0' + (maxDate.getMonth() + 1) : (maxDate.getMonth() + 1);
    const minDay = minDate.getDate() < 10 ? '0' + minDate.getDate() : minDate.getDate();
    const maxDay = maxDate.getDate() < 10 ? '0' + maxDate.getDate() : maxDate.getDate();
    this.minDate = minDate.getFullYear() + '-' + minMonth + '-' + minDay;
    this.maxDate = maxDate.getFullYear() + '-' + maxMonth + '-' + maxDay;

    this.errorNetworkBarsNumber = false;
    this.errorOperatorName = false;
    this.errorAudioProblem = false;
    this.errorProblemTypeContact = false;
    this.errorImeiPhone = false;
    this.errorBrandPhone = false;
    this.errorModelPhone = false;
    this.errorCrossTestDate = false;
    this.errorCrossTestBrandPhone = false;
    this.errorCrossTestModelPhone = false;
    this.errorOperatorProblemValue = false;
    this.errorCorrespondentProblemValue = false;
    this.errorLastCallProblemCorrespondent = false;
    this.errorLastCallProblemOperator = false;
    this.errorLastCallProblemDate = false;
    this.errorLastCallProblemAddress = false;
    this.errorLastCallProblemZipCode = false;
    this.errorLastCallProblemCity = false;
  }

  cancel() {
    this.store.dispatch(new UpdateSelectedProcedure(''));
  }

  setStep(step: number){
    this.step = step;
  }

  confirmation() {
    // @ TODO : add check imei, phone numbers, network bars, date values
    if (this.isValidForm() === false && this.formSubmitted === false) {
      this.formSubmitted = true;
      this.store.dispatch(new SaveMission(this.voiceCallAssistance, this.procedureCode));
    }
  }


  resetAudioProblems() {
    if (this.audioProblem === 0) {
      this.audioProblemValues = [];
    }
  }

  saveAudioProblems(event) {
    if (event.target.checked) {
      this.audioProblemValues.push(event.target.value);
      this.errorAudioProblem = false;
    } else {
      const index = this.audioProblemValues.indexOf(event.target.value);
      this.audioProblemValues.splice(index, 1);
    }
  }

  private isValidForm() {
    let result = true;
    this.errorAudioProblem = false;
    this.errorNetworkBarsNumber = false;
    this.errorOperatorName = false;
    this.errorProblemTypeContact = false;
    this.errorImeiPhone = false;
    this.errorBrandPhone = false;
    this.errorModelPhone = false;
    this.errorCrossTestDate = false;
    this.errorCrossTestBrandPhone = false;
    this.errorCrossTestModelPhone = false;
    this.errorOperatorProblemValue = false;
    this.errorCorrespondentProblemValue = false;
    this.errorLastCallProblemCorrespondent = false;
    this.errorLastCallProblemOperator = false;
    this.errorLastCallProblemDate = false;
    this.errorLastCallProblemAddress = false;
    this.errorLastCallProblemZipCode = false;
    this.errorLastCallProblemCity = false;

    this.voiceCallAssistance.phoneNumber = this.line.phoneNumber;
    this.voiceCallAssistance.step = 1;
    this.voiceCallAssistance.displayedMessage = this.displayedMessage == 1;
    this.voiceCallAssistance.displayedMessageValue = null;
    this.voiceCallAssistance.problemTypeContact = null;
    this.voiceCallAssistance.audioProblemValues = [];
    this.voiceCallAssistance.appearanceProblem = this.appearanceProblem;
    this.voiceCallAssistance.problemDestination = this.problemDestination;
    this.voiceCallAssistance.operatorProblem = this.operatorProblem == 1;
    this.voiceCallAssistance.correspondentProblem = this.correspondentProblem == 1;
    this.voiceCallAssistance.operatorProblemValue = null;
    this.voiceCallAssistance.correspondentProblemValue = null;
    this.voiceCallAssistance.audioProblem = this.audioProblem == 1;
    this.voiceCallAssistance.oldOperatorPhonePurchased = this.oldOperatorPhonePurchased == 1;
    this.voiceCallAssistance.unlockedPhone = this.unlockedPhone == 1;
    this.voiceCallAssistance.crossTestResult = this.crossTestResult == '1';
    this.voiceCallAssistance.problemType = this.problemType;
    this.voiceCallAssistance.occurrenceFrequencyProblem = this.occurrenceFrequencyProblem;
    this.voiceCallAssistance.usageType = this.usageType;
    this.voiceCallAssistance.incidentInformation = this.incidentInformation;
    this.voiceCallAssistance.incidentMagnitude = null;
    this.voiceCallAssistance.incidentMagnitudeCountry = null;

    if (this.incidentInformation == 'Localisé') {
      this.voiceCallAssistance.incidentMagnitude = this.incidentMagnitude;
      if (this.incidentMagnitude == 'Un pays') {
        this.voiceCallAssistance.incidentMagnitudeCountry = this.incidentMagnitudeCountry;
      }
    }

    if (this.displayedMessage == 1) {
      this.voiceCallAssistance.displayedMessageValue = this.displayedMessageValue;
    }

    if (this.audioProblem == 1 && this.audioProblemValues.length == 0) {
      this.errorAudioProblem = true;
    } else {
      this.voiceCallAssistance.audioProblemValues = this.audioProblemValues;
    }

    if (this.networkBarsNumber == undefined || this.networkBarsNumber.toString() == '') {
      this.errorNetworkBarsNumber = true;
    } else {
      this.voiceCallAssistance.networkBarsNumber = this.networkBarsNumber !== undefined ? this.networkBarsNumber : null;
    }

    if (this.operatorName == undefined || this.operatorName == '') {
      this.errorOperatorName = true;
    } else {
      this.voiceCallAssistance.operatorName = this.operatorName !== undefined ? this.operatorName : null;
    }

    if (this.problemType == 'Emission et réception d\'appels' && (this.problemTypeContact == undefined || this.problemTypeContact == '')) {
     this.errorProblemTypeContact = true;
    } else {
      this.voiceCallAssistance.problemTypeContact = this.problemTypeContact !== undefined ? this.problemTypeContact : null;
    }

    if (this.imeiPhone == undefined || this.imeiPhone.toString() == '' || this.imeiPhone.toString().length < 15) {
      this.errorImeiPhone = true;
    } else {
      this.voiceCallAssistance.imeiPhone = this.imeiPhone !== undefined ? this.imeiPhone : null;
    }

    if (this.brandPhone == undefined || this.brandPhone == '') {
      this.errorBrandPhone = true;
    } else {
      this.voiceCallAssistance.brandPhone = this.brandPhone !== undefined ? this.brandPhone : null;
    }

    if (this.modelPhone == undefined || this.modelPhone == '') {
      this.errorModelPhone = true;
    } else {
      this.voiceCallAssistance.modelPhone = this.modelPhone !== undefined ? this.modelPhone : null;
    }

    if (this.crossTestDate == undefined || this.crossTestDate == '') {
      this.errorCrossTestDate = true;
    } else {
      this.voiceCallAssistance.crossTestDate = this.crossTestDate !== undefined ? this.crossTestDate : null;
    }

    if (this.crossTestBrandPhone == undefined || this.crossTestBrandPhone == '') {
      this.errorCrossTestBrandPhone = true;
    } else {
      this.voiceCallAssistance.crossTestBrandPhone = this.crossTestBrandPhone !== undefined ? this.crossTestBrandPhone : null;
    }

    if (this.crossTestModelPhone == undefined || this.crossTestModelPhone == '') {
      this.errorCrossTestModelPhone = true;
    } else {
      this.voiceCallAssistance.crossTestModelPhone = this.crossTestModelPhone !== undefined ? this.crossTestModelPhone : null;
    }

    if (this.operatorProblem == 1 && (this.operatorProblemValue == undefined || this.operatorProblemValue == '')) {
      this.errorOperatorProblemValue = true;
    } else {
      this.voiceCallAssistance.operatorProblemValue = this.operatorProblemValue !== undefined ? this.operatorProblemValue : null;
    }

    if (this.correspondentProblem == 1 && (this.correspondentProblemValue == undefined || this.correspondentProblemValue == '')) {
      this.errorCorrespondentProblemValue = true;
    } else {
      this.voiceCallAssistance.correspondentProblemValue = this.correspondentProblemValue !== undefined ? this.correspondentProblemValue : null;
    }

    if (this.lastCallProblemOperator == undefined || this.lastCallProblemOperator == '') {
      this.errorLastCallProblemOperator = true;
    } else {
      this.voiceCallAssistance.lastCallProblemOperator = this.lastCallProblemOperator !== undefined ? this.lastCallProblemOperator : null;
    }

    if (this.lastCallProblemDate == undefined || this.lastCallProblemDate == '') {
      this.errorLastCallProblemDate = true;
    } else {
      this.voiceCallAssistance.lastCallProblemDate = this.lastCallProblemDate !== undefined ? this.lastCallProblemDate : null;
    }

    if (this.lastCallProblemAddress == undefined || this.lastCallProblemAddress == '') {
      this.errorLastCallProblemAddress = true;
    } else {
      this.voiceCallAssistance.lastCallProblemAddress = this.lastCallProblemAddress !== undefined ? this.lastCallProblemAddress : null;
    }

    if (this.lastCallProblemCorrespondent == undefined || this.lastCallProblemCorrespondent == '') {
      this.errorLastCallProblemCorrespondent = true;
    } else {
      this.voiceCallAssistance.lastCallProblemCorrespondent = this.lastCallProblemCorrespondent !== undefined ? this.lastCallProblemCorrespondent : null;
    }

    if (this.lastCallProblemZipCode == undefined || this.lastCallProblemZipCode == '') {
      this.errorLastCallProblemZipCode = true;
    } else {
      this.voiceCallAssistance.lastCallProblemZipCode = this.lastCallProblemZipCode !== undefined ? this.lastCallProblemZipCode : null;
    }

    if (this.lastCallProblemCity == undefined || this.lastCallProblemCity == '') {
      this.errorLastCallProblemCity = true;
    } else {
      this.voiceCallAssistance.lastCallProblemCity = this.lastCallProblemCity !== undefined ? this.lastCallProblemCity : null;
    }

    if (
        this.errorAudioProblem == true ||
        this.errorNetworkBarsNumber == true ||
        this.errorOperatorName == true ||
        this.errorProblemTypeContact == true ||
        this.errorImeiPhone == true ||
        this.errorBrandPhone == true ||
        this.errorModelPhone == true ||
        this.errorCrossTestDate == true ||
        this.errorCrossTestBrandPhone == true ||
        this.errorCrossTestModelPhone == true ||
        this.errorOperatorProblemValue == true ||
        this.errorCorrespondentProblemValue == true ||
        this.errorLastCallProblemCorrespondent == true ||
        this.errorLastCallProblemOperator == true ||
        this.errorLastCallProblemDate == true ||
        this.errorLastCallProblemAddress == true ||
        this.errorLastCallProblemZipCode == true ||
        this.errorLastCallProblemCity == true
    ) {
      result = false;
    }

    return result;
  }
}
